module.exports = {"id":"187936","name":"Steven N'Zonzi","rating":"83","photo":"./data/images/photos/2/187936.png","club":{"name":"Séville FC","logo":"./data/images/clubs/SevilleFC.png"},"positions":["MDC","MC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/StevenN'Zonzi0.json
// module id = 4041
// module chunks = 0